import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pp-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class PpLoaderComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
